export const globalState = (state) => state.appState.global;
export const trackHistoryDuration = (state) => state.appState.global.trackHistory.duration;
export const getScrollBarAppState = (state) => {
	return state?.appState?.global?.scrollBarsEnabled ?? false;
};
